import { Stack, Typography, Divider } from "@mui/material";

interface ScheduleItemProps {
  label: string;
  value?: string | null;
  icon: React.ReactNode;
}

export default function ScheduleItem({
  label,
  value,
  icon,
}: ScheduleItemProps) {
  return (
    <Stack>
      <Typography variant="caption" color="GrayText">
        {label}
      </Typography>
      <Stack direction={"row"} alignItems="center" spacing={1}>
        <Typography color={!value ? "GrayText" : undefined}>{icon}</Typography>
        <Typography>{value}</Typography>
      </Stack>
      <Divider />
    </Stack>
  );
}
